module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0058.jpg?v=a435d1c2";